import * as React from 'react';
import type { SVGProps } from 'react';

const IconArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 16" {...props}>
    <path
      d="M.851 7.07a1 1 0 0 0 0 1.414l6.364 6.364a1 1 0 0 0 1.415-1.414L2.973 7.777 8.63 2.12A1 1 0 1 0 7.215.706L.851 7.07Zm17.708-.293h-17v2h17v-2Z"
      fill="currentColor"
    />
  </svg>
);
export default IconArrow;
